import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TruncatePipe } from 'src/app/shared/pipes/truncate/truncate.pipe';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-tabela-paginacao',
  standalone: true,
  imports: [CommonModule, FormsModule, TruncatePipe],
  templateUrl: './tabela-paginacao.component.html',
  styleUrls: ['./tabela-paginacao.component.scss'],
})
export class TabelaPaginacaoComponent implements OnInit {
  @Input() columns: Array<{
    label: string;
    field: string;
    sortable?: boolean;
    template?: TemplateRef<any>;
    title?: string;
  }> = [];
  @Input() data: Array<any> = [];
  @Input() trackByFn: (index: number, item: any) => any = (index, item) => item;

  @Input() pagination: {
    pageNext: number;
    pagePrev: number;
    recordsCount: number;
    pageFirst: number;
    pageLast: number;
    pageActive: boolean;
    page: number;
    pageSize: number;
    shortcuts: number;
    hasValue: boolean;
    shortcutPages: any[];
    records: any[];
    ordenation?: string;
  } = {
    pageNext: 0,
    pagePrev: 0,
    recordsCount: 0,
    pageFirst: 1,
    pageLast: 1,
    pageActive: true,
    page: 1,
    pageSize: 10,
    shortcuts: 0,
    hasValue: false,
    shortcutPages: [],
    records: [],
  };

  @Output() pageChange = new EventEmitter<number>();
  @Output() paginaMudada = new EventEmitter<number>();
  @Output() rowClick = new EventEmitter<any>();
  @Output() workNameClick = new EventEmitter<number>();
  @Output() companyNameClick = new EventEmitter<any>();
  @Output() loaderActivate = new EventEmitter<void>();
  @Output() loaderDeactivate = new EventEmitter<void>();

  BASE_IMG_URL: string = environment.BASE_IMG_URL;

  constructor() {}

  ngOnInit() {}

  ordenarPorCampo(field: string): void {
    if (!field) return;

    const isDateField = field.toLowerCase().includes('date');

    const isDescending = this.pagination.ordenation === field;
    this.pagination.ordenation = isDescending ? `${field}_desc` : field;

    this.data.sort((a, b) => {
      const valueA = isDateField ? new Date(a[field]) : a[field];
      const valueB = isDateField ? new Date(b[field]) : b[field];

      if (isDateField) {
        const timeA = isNaN(valueA.getTime()) ? 0 : valueA.getTime();
        const timeB = isNaN(valueB.getTime()) ? 0 : valueB.getTime();

        return isDescending ? timeB - timeA : timeA - timeB;
      }

      if (typeof valueA === 'string' && typeof valueB === 'string') {
        return isDescending
          ? valueB.localeCompare(valueA)
          : valueA.localeCompare(valueB);
      }

      return isDescending
        ? valueA < valueB
          ? 1
          : valueA > valueB
          ? -1
          : 0
        : valueA > valueB
        ? 1
        : valueA < valueB
        ? -1
        : 0;
    });
  }

  onPageChange(page: number): void {
    this.pageChange.emit(page);
  }

  mudarPagina(direcao: number): void {
    const novaPagina = this.pagination.page + direcao;
    if (
      novaPagina >= this.pagination.pageFirst &&
      novaPagina <= this.pagination.pageLast
    ) {
      this.loaderActivate.emit();
      this.pagination.page = novaPagina;
      this.paginaMudada.emit(novaPagina);
      this.loaderDeactivate.emit();
    }
  }

  onRowClick(row: any): void {
    this.rowClick.emit(row);
  }

  onWorkNameClick(workId: number): void {
    this.workNameClick.emit(workId);
  }

  onCompanyNameClick(row: any): void {
    this.companyNameClick.emit(row);
  }
  
  get visiblePages(): number[] {
    const maxVisible = 10;
    const pages: number[] = [];
    const total = this.pagination.pageLast;
    const current = this.pagination.page;

    let start = Math.max(1, current - Math.floor(maxVisible / 2));
    let end = start + maxVisible - 1;

    if (end > total) {
      end = total;
      start = Math.max(1, end - maxVisible + 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  }
}
